import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'supported-client-type',
    pluginName: 'SUPPORTED_CLIENT_TYPE',
    entityName: 'SUPPORTED_CLIENT_TYPE',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    createFailedUseBackendMessage: true,
    createSuccessUseBackendMessage: true,
    deleteFailedUseBackendMessage: true,
    editFailedUseBackendMessage: true,
    bulkDeleteFailedUseBackendMessage: true
});

// Fetch supportedClientType action creators
export const fetchSupportedClientTypeInit = () => {
    return crudActions.fetchInit();
};
export const fetchSupportedClientTypeStart = () => {
    return crudActions.fetchStart();
};
export const fetchSupportedClientTypeSuccess = (fetchSupportedClientTypeCount, listSupportedClientTypeCount) => {
    return crudActions.fetchSuccess(fetchSupportedClientTypeCount, listSupportedClientTypeCount);
};
export const fetchSupportedClientTypeFail = () => {
    return crudActions.fetchFail();
};
export const fetchSupportedClientTypeCount = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchSupportedClientTypeStart());
        try {
            let countRes = await rest.post("supported-client-type/count", filterData, { cancelToken: options.countSource.token });
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchSupportedClientTypeSuccess(0, []));
                }
                return { data: countRes.data.result.data }
            }
            if (countRes && countRes.canceled) {
                return { data: 0, canceled: true };
            }
            dispatch(fetchSupportedClientTypeFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch supported client type."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: 0 };
        } catch (error) {
            dispatch(fetchSupportedClientTypeFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch supported client type."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: 0 };
        }
    }
}

export const fetchSupportedClientType = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchSupportedClientTypeStart());
        try {
            let listRes = await rest.post("supported-client-type/list", filterData, { cancelToken: options.listSource.token });
            if (listRes && listRes.canceled) {
                return { data: [], canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchSupportedClientTypeSuccess(filterData.count, listRes.data.result.data));
                return { data: listRes.data.result.data };
            }
            dispatch(fetchSupportedClientTypeFail());
            return { data: [] };
        }
        catch (error) {
            dispatch(fetchSupportedClientTypeFail());

            return { data: [] };
        }
    }
}

// Load supportedClientType action creators
export const loadSupportedClientTypeInit = () => { return crudActions.loadInit() };
export const loadSupportedClientTypeStart = () => { return crudActions.loadStart(); };
export const loadSupportedClientTypeSuccess = loadedSupportedClientType => { return crudActions.loadSuccess(loadedSupportedClientType); };
export const loadSupportedClientTypeFail = error => { return crudActions.loadFail(error); };
export const loadSupportedClientType = (loadParams, options = {}) => {
    return async dispatch => {
        await crudActions.load(dispatch, loadParams, options);
    };
};

export const createSupportedClientType = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/supported-client-type/create', params);
            if (res.data && res.data.succeeded) {
                // Next line is commented because of cancel request, will be removed
                //dispatch(createSupportedClientTypeSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully created supported client type.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create supported client type."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const editSupportedClientType = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/supported-client-type/save', params);
            if (res.data && res.data.succeeded) {
                // Next line is commented because of cancel request, will be removed
                //dispatch(editSupportedClientTypeSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated supported client type.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit supported client type."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete product type 
export const bulkDeleteSupportedClientTypesInit = () => {
    return crudActions.bulkDeleteInit()
};
export const bulkDeleteSupportedClientTypesStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteSupportedClientTypesSuccess = result => {
    return crudActions.bulkDeleteSuccess(result);
};
export const bulkDeleteSupportedClientTypesFail = error => {
    return crudActions.bulkDeleteFail(error);
};

export const bulkDeleteSupportedClientTypes = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteSupportedClientTypesStart());
        try {
            let res = await rest.post('/supported-client-type/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteSupportedClientTypesSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted supported client type.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteSupportedClientTypesFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete supported client type."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete supported client type."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteSupportedClientTypesFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const listPermissions = (data, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/permissions/list', { listAll: true, ...data }, options);
            if (res.data && res.data.succeeded) {
                let permissions = [];
                for (var permission of res.data.result.data) {
                    permissions.push({ value: permission.PermissionID, label: `${permission.Name}` });
                }
                return permissions;
            } else {
                if (res && res.canceled) {
                    return [];
                }
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list permissions."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
        }
    };
}

export const listCustomers = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/customers/list', { listAll: true, ...data });
            if (res.data && res.data.succeeded) {
                let customers = [];
                for (var customer of res.data.result.data) {
                    customers.push({ value: customer.CustomerID, displayValue: `${customer.Name}` });
                }
                return customers;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list customer."}`,
                options: {
                    variant: 'warning'
                }
            });
            return [];
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
        }
    };
}